import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.js';
import '../node_modules/fullcalendar-reactwrapper/dist/css/fullcalendar.min.css'
import { combineReducers, createStore } from 'redux';
import { Provider } from 'react-redux';
import productsReducer from './reducers/cart-reducer';
import userReducer from './reducers/user-reducer';
import alertReducer from './reducers/alert-reducer';
import calendarReducer from './reducers/calendar-reducer';

const allReducers = combineReducers({
    products: productsReducer,
    user: userReducer,
    alert: alertReducer,
    calendar: calendarReducer
});

const store = createStore(
    allReducers,
    {
        products: [],
        user: '',
        alert: '',
        calendar: ''
    },
    window.devToolsExtension && window.devToolsExtension()
    );

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js